(function () {
  if (window.PLPAjaxCartInitialized) return;
  window.PLPAjaxCartInitialized = true;

  const ajaxButtonSelector = '[data-plp-ajax-cart-button]';

  function getQuantity(form) {
    const quantity = Number(new FormData(form).get('quantity'));
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function updateCartCount(quantityAdded) {
    const countElements = document.querySelectorAll('[data-plp-cart-count], .site-header__icons a[href*="/cart"] sup');

    countElements.forEach((countElement) => {
      const currentCount = Number(countElement.textContent.trim()) || 0;
      const nextCount = Math.max(0, currentCount + quantityAdded);
      countElement.textContent = String(nextCount);

      const cartLink = countElement.closest('a[href*="/cart"]');
      if (cartLink) {
        cartLink.setAttribute('aria-label', `Cart, ${nextCount} ${nextCount === 1 ? 'item' : 'items'}`);
      }
    });
  }

  function setButtonText(button, text) {
    if (!button) return;
    if (!button.dataset.plpOriginalText) {
      button.dataset.plpOriginalText = button.textContent.trim();
    }
    button.textContent = text;
  }

  function resetButtonText(button) {
    if (!button || !button.dataset.plpOriginalText) return;
    button.textContent = button.dataset.plpOriginalText;
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    const submitter = event.submitter || document.activeElement;

    if (!(form instanceof HTMLFormElement) || !submitter || !submitter.matches(ajaxButtonSelector)) return;

    event.preventDefault();

    if (submitter.disabled) return;

    const endpoint = `${form.getAttribute('action') || '/cart/add'}.js`;
    const quantity = getQuantity(form);
    const formData = new FormData(form);

    submitter.disabled = true;
    setButtonText(submitter, 'Added');
    updateCartCount(quantity);

    window.setTimeout(() => {
      resetButtonText(submitter);
      submitter.disabled = false;
    }, 520);

    (async () => {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Could not add item to cart.');
      }
    })().catch(() => {
      updateCartCount(-quantity);
      setButtonText(submitter, 'Try again');

      window.setTimeout(() => {
        resetButtonText(submitter);
        submitter.disabled = false;
      }, 1800);
    });
  });
})();
